module.exports = __webpack_public_path__ + "img/gengxin1.6bca8b70.png";